import type { Key, Selection } from "react-aria-components";

export function selectionToNumberIds(
	keys: Selection,
	allIds: number[] = []
): number[] {
	if (keys === "all") {
		return allIds;
	}

	return [...keys]
		.map((key: Key) => Number(key))
		.filter((id) => !Number.isNaN(id));
}
